import { IAffairPub } from "@api/affair.int";
import { IUserPub } from "@api/auth.int";
import { IProfileAffairsGetApi } from "@api/profile.int";
import { Box, Divider, Text, useBoolean } from "@chakra-ui/react";
import { useDeepAuth, useVVApi } from "components/api";
import { AFFAIR_KINDS, Bogyo, GUARD_KINDS } from "components/appComponents";
import { DeepErrorBox, DeepErrorContainer } from "components/misc";
import { HitBogyo, HitBox, HitLineMain, HitLineSub, HitRight, PaginatorBox, usePaginator } from "components/paginator";
import { isLocationAffair, useVVStore } from "components/store";
import { formatDate, formatDateTime } from "components/utils";
import { VizvCard, VizvCardContent, VizvCardHeaderPopup, VizvMainCol } from "components/vizvComponents";
import { NavMainLink } from "features/NavMain";
import { useEffect, useState } from "react";
import { Outlet, useNavigate, useParams } from "react-router";


type TPage = IProfileAffairsGetApi['response']['payload'];

export function ProfileAffairs() {
    const routeParams = useParams();
    const isDetailed = !!routeParams.affairKey;
    const userKey = routeParams.userKey;
    const api = useVVApi();

    const auth = useDeepAuth();

    const guardList = useVVStore(state => state.guardList);

    const nav = useNavigate();
    const navRoot = `/profile-affairs/${userKey}`;

    const paginator = usePaginator({
        parse: (p: TPage) => ({ items: p.affairs, nextKeys: p.nextKeys }),
        deps: [userKey],
        loadNext: async (fromKeys) => {
            if (!userKey)
                return Promise.resolve({ affairs: [] });
            const resp = await api.fetch<IProfileAffairsGetApi>({
                url: '/auth/profile/:userKey/affairs', method: 'GET', params: { userKey }, query: { ...fromKeys && { fromKeys } }
            });
            resp.affairs = resp.affairs.filter(a => !a.deletedBy);
            return resp;
        }
    });



    useEffect(() => {

    }, [userKey]);

    const [guard, setGuard] = useState<IUserPub>();
    const [navBack, setNavBack] = useState('')
    useEffect(() => {
        if (!userKey) {
            setGuard(undefined);
            setNavBack('');
        } else if (auth.signedUser?.userKey === userKey) {
            setGuard(auth.userAny);
            setNavBack('');
        } else {
            const g = guardList.find(g => g.userKey === userKey);
            if (g) {
                setGuard(g);
                setNavBack(`/guard/${g.userKey}`);
            } else {
                setGuard(undefined);
                setNavBack('');
            }
        }

    }, [userKey, guardList, auth.signedUser])


    return <>
        <VizvMainCol isTool={{ width: 400, isDetailed }} mapNavRoot={navRoot} >
            <VizvCard isTool isClosable {...navBack && { onBack: () => nav(navBack) }}>

                <VizvCardHeaderPopup fontSize='x-large' fontWeight='400' variant="blue" mb={2}
                //{...parent && { mt: 0 }}
                >
                    {auth && auth.signedUser && userKey && auth.signedUser.userKey == userKey ? 'Bejelentéseim' : (
                        guard ? <Box>
                            <span>{guard?.guard?.name || guard.userName}</span><br /><Text fontSize='sm' lineHeight='normal'>Bejelentései</Text>
                        </Box> : 'Bejelentések'
                    )}

                </VizvCardHeaderPopup>
                {guard && <HitBox hit={{ user: guard }}>
                    <HitBogyo />
                    <HitRight>
                        {/*<HitLineSub>{formatDate(guard.createdAt)}</HitLineSub>*/}
                        <HitLineMain>{guard.guard?.name || guard.userName}</HitLineMain>
                        <HitLineSub>
                            {guard.guard ? GUARD_KINDS[guard.guard.kind].name : 'Felhasználó'}
                            {guard.userSummary.jelentettCount > 0 && <>, {guard.userSummary.jelentettCount} bejelentés</>}
                        </HitLineSub>

                    </HitRight>
                </HitBox>}
                <Divider my={2} />


                <PaginatorBox pager={paginator} item={affair => <HitBox
                    //key={hix}
                    hit={{ affair }}
                >
                    <HitBogyo />
                    <HitRight>
                        <HitLineSub>{formatDateTime(affair.createdAt)}</HitLineSub>
                        <HitLineMain>{affair.title}</HitLineMain>
                        <HitLineSub>{AFFAIR_KINDS[affair.affairKind].name}</HitLineSub>

                    </HitRight>
                </HitBox>

                } />

            </VizvCard>
        </VizvMainCol>
        <Outlet />
    </>
}